import config from '@app/config';
import { BannerType } from '../types/bannerSchema';

export const ActionShinomontaj: BannerType = {
  imageDesktop: `${config.baseImageUrl}/articles/wp-content/uploads/2023/10/opening_Yrickogo_2023_1140x100.jpg`,
  imageMobile: `${config.baseImageUrl}/articles/wp-content/uploads/2023/10/opening_Yrickogo_2023_634x414.jpg`,
  href: 'https://vrn.koleso.ru/actions/shinomontaj-i-sezonnoe-hranenie-v-podarok-ves-noyabr-pri-pokupke-lyubogo-komplekta-shin-ili-diskov-na-uritskogo--d-20',
  options: {
    widthDesktop: 1140,
    heightDesktop: 100,
    widthMobile: 634,
    heightMobile: 414,
  },
};

export const ActionTruckTyresShinomontaj: BannerType = {
  imageDesktop: `${config.baseImageUrl}/upload/medialibrary/banners/13_3047.png`,
  imageMobile: `${config.baseImageUrl}/upload/medialibrary/banners/13_3049.png`,
  href: ' /actions/besplatnyiy-montaj-gruzovyih-shin-satoya-i-armstrong/',
  options: {
    widthDesktop: 2280,
    heightDesktop: 200,
    widthMobile: 1268,
    heightMobile: 828,
  },
};

export const ActionNighniyNovgorod: BannerType = {
  imageDesktop: `${config.baseImageUrl}/upload/medialibrary/banners/13_3039.png`,
  imageMobile: `${config.baseImageUrl}/upload/medialibrary/banners/13_3040.png`,
  href: '/actions/darim-podarki-za-pokupku/',
  options: {
    widthDesktop: 2280,
    heightDesktop: 200,
    widthMobile: 2280,
    heightMobile: 600,
  },
};

export const Action24HourTireService: BannerType = {
  imageDesktop: `${config.baseImageUrl}/upload/medialibrary/banners/13_3033.png`,
  imageMobile: `${config.baseImageUrl}/upload/medialibrary/banners/13_3034.png`,
  href: '/actions/aktsiya-v-chest-otkryitiya-shinnogo-tsentra/',
  options: {
    widthDesktop: 1140,
    heightDesktop: 100,
    widthMobile: 1440,
    heightMobile: 575,
  },
};

export const ActionRostovOnDon: BannerType = {
  imageDesktop: `${config.baseImageUrl}/upload/medialibrary/banners/13_3037.png`,
  imageMobile: `${config.baseImageUrl}/upload/medialibrary/banners/13_3038.png`,
  href: '/actions/aktsiya-v-chest-otkryitiya-shinnogo-tsentra/',
  options: {
    widthDesktop: 2280,
    heightDesktop: 200,
    widthMobile: 1152,
    heightMobile: 460,
  },
};

export const ActionFreeBatteryDiagnostics: BannerType = {
  imageDesktop: `${config.baseImageUrl}/upload/medialibrary/banners/13_3053.png`,
  imageMobile: `${config.baseImageUrl}/upload/medialibrary/banners/13_3054.png`,
  href: '/actions/diagnostika-akkumulyatora-besplatno/',
  options: {
    widthDesktop: 2280,
    heightDesktop: 600,
    widthMobile: 1268,
    heightMobile: 828,
  },
};

export const arrayConnectBannerByShopId = [
  {
    shopIds: [260],
    banners: [ActionShinomontaj],
  },
  {
    shopIds: [81, 79],
    banners: [ActionNighniyNovgorod],
  },
  {
    shopIds: [141, 145],
    banners: [ActionTruckTyresShinomontaj],
  },
  {
    shopIds: [
      83, 618, 95, 98, 93, 300, 189, 288, 33, 298, 197, 41, 301, 299, 192, 302, 198, 190, 290, 18, 40, 200, 153, 99, 89, 87, 160, 158, 306, 454,
      313, 145, 6, 229, 81, 154, 146, 304, 15, 157, 183, 184, 271, 292, 63, 296, 215, 452, 291, 388, 44, 150, 364, 61, 43, 218, 805, 596, 1017,
      1225, 1296, 1226, 1659, 1656, 1645,
    ],
    banners: [ActionFreeBatteryDiagnostics],
  },
];
